import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  AriaRole,
  LinkAriaAttribute,
  LinkButtonIconName,
  PButton,
  PButtonPure,
  PLink,
  PLinkPure,
  SelectedAriaAttributes,
} from '@porsche-design-system/components-react';
import type { MouseEventHandler } from 'react';

export const InlineNavigation = styled('ul', {
  base: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,

    '& li': {
      display: 'block',
      padding: 0,
      paddingBottom: 'xs',
      margin: 0,
    },
  },
});

export const Navigation = styled('ul', {
  base: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
});

export const NavigationItem = styled('li', {
  base: {
    margin: 0,
    paddingLeft: 'sm',
    paddingRight: 'sm',
    display: 'inline-block',
    verticalAlign: 'middle',
  },

  variants: {
    spacing: {
      medium: {
        paddingLeft: 'md',
        paddingRight: 'md',
      },
    },
    divider: {
      true: {
        paddingRight: 'md',
        marginRight: 'sm',
        paddingLeft: 0,
        borderRight: '1px solid',
        borderRightColor: 'border.contrastHigh',
      },
    },
  },
});

const NavigationPureLink = styled(PLinkPure, {
  base: {
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
  },
  variants: {
    isActive: {
      true: {
        borderBottomColor: 'border.primary',
        '&:hover': {
          borderBottomColor: 'transparent',
        },
      },
    },
  },
});

export const NavigationLink = (props: {
  href?: string;
  icon?: LinkButtonIconName;
  isActive?: boolean;
  aria?: SelectedAriaAttributes<LinkAriaAttribute>;
  children?: React.ReactNode;
  iconSource?: string;
  hideLabel?: boolean;
  onClick?: MouseEventHandler<{}>;
  role?: AriaRole;
}) => {
  if (typeof props.onClick === 'function') {
    const { href, isActive: _isActive, ...rest } = props;

    if (href) {
      return <PLink compact href={href} variant="secondary" {...rest} />;
    }

    if (props.hideLabel) {
      return (
        <PButtonPure
          type="button"
          hideLabel
          onClick={props.onClick}
          {...rest}
        />
      );
    }

    return <PButton compact type="button" variant="secondary" {...rest} />;
  }

  return <NavigationPureLink {...props} />;
};
